if (!customElements.get('service-product')) {
  customElements.define(
    'service-product',
    class ServiceProduct extends HTMLElement {
      connectedCallback() {
        if (this._populated) return;
        this._populated = true;
        this.populateFromSession();
      }

      getCurrentHandle() {
        const pageHandle = this.getAttribute('data-page-handle') || '';
        return pageHandle.split('-').slice(1).join('-');
      }

      getProductData(replacement) {
        const rootUrl = (window.theme?.routes?.root_url || '').replace(/\/$/, '');
        const productPath = replacement.startsWith('/') ? replacement : `/${replacement}`;
        const url = `${rootUrl}${productPath}`;

        return fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error(`Product fetch failed: ${response.status}`);
            return response.text();
          })
          .then((html) => new DOMParser().parseFromString(html, 'text/html'));
      }
 

      populateFromSession() {
        const card = this.querySelector('.service-product');
        const button = this.querySelector('.service-product__button');
        
        if (!card || !button) return;

        const market = this.getAttribute('data-market') || 'de';
        const language = this.getAttribute('data-language') || 'de';

        fetch(`https://fritz-regex-app.prod.fritz.support/api/regex-rules?shop=avm-deutschland.myshopify.com&market=${market}&language=${language}`)
          .then(response => response.json())
          .then(data => {
            const currentHandle = '/products/' + this.getCurrentHandle() + '$';
            const matchedRule = data.rules.find(rule => rule.pattern === currentHandle);
            if (matchedRule) {
              this.getProductData(matchedRule.replacement).then((doc) => {
                const button = doc.querySelector('.productsevice .productsevice__button');
                // Extended the logic to check if the matchedRule is the same as the product, as on Fritz!Fon M2, the product was shown as M3
                const matchedHandle = matchedRule.replacement.split('/').at(-1);
                if (button && button.dataset.product == matchedHandle) {
                  const buttonLink = this.querySelector('#service-product-button');
                  const title = this.querySelector('.service-product__title');
                  const subtitle = this.querySelector('.service-product__subtitle');
                  const price = this.querySelector('.service-product__price');
                  const image = this.querySelector('.service-product__media img');
                  const comparedPrice = this.querySelector('.service-product__compared-price');

                  if (title) title.textContent = button.dataset.title || '';
                  if (subtitle) subtitle.textContent = button.dataset.subtitle || '';
                  if (price) price.textContent = button.dataset.price || '';
                  if (comparedPrice) comparedPrice.textContent = button.dataset.comparedPrice || '';
                  if (image) image.src = button.dataset.image || '';
                  buttonLink.href = buttonLink.href + matchedRule.replacement.split('/').slice(1).join('/');

                  card.style.opacity = '1';
                }
              });
            } else {
              card.style.display = 'none';
              console.log('No regex rule matched for path:', currentHandle);
            }
          })
      }
    }
  );
}
